import _ from 'lodash'
import { TmrMovementHelper } from 'tmr/resources/movement/movementHelper'

/**
 * Helper service for handling movements.
 *
 * @type {ngService}
 */
export class TmrMovementByUpcHelper extends TmrMovementHelper {
  /**
   * Groups read items by unexpected and upc.
   * Used in inbound operations after a status request.
   *
   * @param {object} details the status request response
   * @param {array} antenna.$epcs
   * @param {object} antenna.$itemsByEpc
   * @param {object} antenna.$products
   * @param {Parcel.parcelItems} parcelItems the items from a parcel
   *
   * @returns {array}
   */
  groupitemsByExpectedUpc(
    details,
    { $epcs, $itemsByEpc, $products },
    productAndQty = {}
  ) {
    let groups = []

    // Cycle $epcs instead of $itemsByEpc because they are ordered by last read.
    $epcs.forEach(epc => {
      if (details[epc] !== undefined && $itemsByEpc[epc] !== undefined) {
        // Creates data grouped by unexpected and upc for the table.
        let unexpected = details[epc].unexpected
        let upc = $itemsByEpc[epc].upc
        let group = groups.find(
          group => group.upc == upc && group.unexpected == unexpected
        )

        // New group.
        if (group === undefined) {
          group = this.buildGroup(
            upc,
            unexpected,
            [],
            productAndQty[upc],
            $products[upc]
          )
          groups.push(group)
        }

        // Update group.
        this.updateGroupData(group, details, epc, groups)
      }
    })

    // Add missing groups of expected parcel items
    for (let upc in productAndQty) {
      if (
        groups.find(group => group.upc == upc && !group.unexpected) ===
        undefined
      ) {
        groups.push(
          this.buildGroup(upc, false, [], productAndQty[upc], $products[upc])
        )
      }
    }

    groups.sort((a, b) => this.sortGroups(a, b))

    return groups
  }

  /**
   * Counts expected and detected items of a list of groups
   */
  countExpectedDetected(groups) {
    return _.reduce(
      groups,
      (memo, group) => memo + (group.unexpected ? 0 : group.epcs.length),
      0
    )
  }

  hasExpectedUnexpectedOk(groups) {
    if (
      this.TmrOperationHelper.getConfig(
        'checklistValidationCheckExpectedUnexpected'
      )
    ) {
      let expected = _.filter(groups, { unexpected: false })
      return _.reduce(
        expected,
        (memo, group) => memo && group.epcs.length == group.expectedEpcsQty,
        true
      )
    }
    return true
  }
}
